/**
 * Picks the arrivals nearest a requested instant and returns them in
 * chronological order (the finder card shows up to three)
 */
export default function getNearestSeatingTimes(
  startsAts: string[],
  requestedUtc: string,
  count = 3,
): string[] {
  const requested = new Date(requestedUtc).getTime()

  return [...new Set(startsAts)]
    .map(startsAt => ({
      startsAt,
      time: new Date(startsAt).getTime(),
    }))
    .sort(
      (a, b) =>
        Math.abs(a.time - requested) - Math.abs(b.time - requested) ||
        a.time - b.time,
    )
    .slice(0, count)
    .sort((a, b) => a.time - b.time)
    .map(({ startsAt }) => startsAt)
}
